import styles from './WarrantyReturnsPageContainer.module.scss';

interface WarrantyReturnsPageContainerProps {
  children: React.ReactNode;
}

export const WarrantyReturnsPageContainer = ({
  children,
}: WarrantyReturnsPageContainerProps) => (
  <p className={`${styles['warrantyReturns__page-container']}`}>{children}</p>
);
